// This exists for mocking purposes.
export const copyToClipboard = (text: string) =>
  navigator.clipboard.writeText(text);
